import type { PostHogEventName, PostHogEventProperties } from '@shared/types/analytics';
// Must use the slim entry — see `posthogClient.ts`. Importing the default
// `posthog-js` here would ship a second SDK copy in the bundle.
import posthog from 'posthog-js/dist/module.slim';

type HasRequiredKeys<T> = {} extends T ? false : true;

export function capture<T extends PostHogEventName>(
    ...args: HasRequiredKeys<PostHogEventProperties<T>> extends true
        ? [event: T, properties: PostHogEventProperties<T>]
        : [event: T, properties?: PostHogEventProperties<T>]
): void {
    const [event, properties] = args;
    posthog.capture(event, properties);
}
